import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import DateRange from "../../dateRange/DateRange";
import {
  faSearch,
  faSyncAlt,
  faChevronUp,
  faChevronDown,
} from "@fortawesome/free-solid-svg-icons";
import "./TrackDeploymentFilter.css";
import { DEFAULT_DAYS_UPLOADEDFILES_DATA } from "../../../utils/constants";
import dayjs from "dayjs";

const StatusValue = [
  { label: "Completed", api: "COMPLETED" },
  { label: "In Progress", api: "IN_PROGRESS" },
  { label: "Resolved", api: "RESOLVED" },
  { label: "Failed", api: "FAILED" },
  { label: "Removed", api: "REMOVED" },
  { label: "Canceled", api: "CANCELED" },
  { label: "Queued", api: "QUEUED" },
  { label: "Timeout", api: "TIMEOUT" },
];

const DEFAULT_RANGE_DAYS = DEFAULT_DAYS_UPLOADEDFILES_DATA;

const TrackDeploymentFilter = ({ onSearch, onReset }) => {
  const { t } = useTranslation();

  const [deploymentName, setDeploymentName] = useState("");
  const [collapsed, setCollapsed] = useState(false);
  const [jobType, setJobType] = useState("");
  const [status, setStatus] = useState("");

  const nowFloored = dayjs();
  const [startDate, setStartDate] = useState(() =>
    nowFloored.subtract(DEFAULT_RANGE_DAYS, "day")
  );
  const [endDate, setEndDate] = useState(() => nowFloored);
  const [rangeError, setRangeError] = useState("");

  const buildSearchData = () => {
    const raw = {
      jobId: deploymentName,
      status: status,
      targetSelection: jobType,
      fromDate: startDate.toISOString(),
      toDate: endDate.toISOString(),
    };

    const filtered = {};
    Object.keys(raw).forEach((k) => {
      if (raw[k] !== "" && raw[k] !== null && raw[k] !== undefined) {
        filtered[k] = raw[k];
      }
    });
    return filtered;
  };

  const handleSearch = async () => {
    if (rangeError) return;
    onSearch?.(buildSearchData());
  };

  const handleReset = () => {
    setStatus("");
    setJobType("");
    setDeploymentName("");
    setStatus("");
    const now = dayjs();
    setStartDate(now.subtract(DEFAULT_RANGE_DAYS, "day"));
    setEndDate(now);
    setRangeError("");
    onReset?.({});
  };
  return (
    <div className="card my-2 bg-light no-border position-relative">
      <div className="card-body">
        {!collapsed && (
          <div className="row g-1 align-items-center">
            {/* Input Field */}
            <div className="col-12 col-md-4">
              <label className="form-label">{t("Deployment name")}</label>
              <input
                type="text"
                className="form-control"
                value={deploymentName}
                onChange={(e) => setDeploymentName(e.target.value)}
                placeholder={t("Enter deployment name")}
              />
            </div>

            {/* Dropdown 1 - Status */}
            <div className="col-12 col-md-4">
              <label className="form-label">{t("Status")}</label>
              <select
                className="form-select"
                value={status}
                onChange={(e) => setStatus(e.target.value)}
              >
                <option value="">{t("Select Status")}</option>
                {StatusValue.map((item) => (
                  <option key={item.api} value={item.api}>
                    {item.label}
                  </option>
                ))}
              </select>
            </div>

            {/* Dropdown 2 - Target Selection */}
            <div className="col-12 col-md-4">
              <label className="form-label">{t("Job Type")}</label>
              <select
                className="form-select"
                value={jobType}
                onChange={(e) => setJobType(e.target.value)}
              >
                <option value="">{t("Select Job Type")}</option>
                <option value="SNAPSHOT">{t("SNAPSHOT")}</option>
                <option value="CONTINUOUS">{t("CONTINUOUS")}</option>
              </select>
            </div>

           
            <div className="col-12 mt-4">
              <div className="row g-2 align-items-center">
                {/* Collapse button */}
                <div className="col-auto d-flex align-items-center">
                  <button
                    type="button"
                    className="btn btn-transperant"
                    onClick={() => setCollapsed((v) => !v)}
                    aria-label={collapsed ? t("Expand") : t("Collapse")}
                    title={collapsed ? t("Expand") : t("Collapse")}
                  >
                    <FontAwesomeIcon
                      icon={collapsed ? faChevronDown : faChevronUp}
                    />
                  </button>
                </div>

                {/* DateRange picker */}
                <div className="col">
                  <DateRange
                    defaultDays={DEFAULT_RANGE_DAYS}
                    startTime={startDate}
                    endTime={endDate}
                    onChange={({
                      startDate: s,
                      endDate: e,
                      rangeError: err,
                    }) => {
                      setStartDate(s);
                      setEndDate(e);
                      setRangeError(err);
                    }}
                  />
                </div>

                {/* Actions */}
                <div className="col-auto d-flex gap-2">
                  <button className="btn btn-primary" onClick={handleSearch}>
                    <FontAwesomeIcon icon={faSearch} className="me-1" />
                    {t("Search")}
                  </button>
                  <button className="btn btn-secondary" onClick={handleReset}>
                    <FontAwesomeIcon icon={faSyncAlt} className="me-1" />
                    {t("Reset")}
                  </button>
                </div>
              </div>
            </div>
          </div>
          //   </div>
        )}

        {collapsed && (
          <div className="d-flex align-items-center">
            <button
              type="button"
              className="btn-transperant"
              onClick={() => setCollapsed((v) => !v)}
              aria-label={collapsed ? t("Expand") : t("Collapse")}
              title={collapsed ? t("Expand") : t("Collapse")}
            >
              <FontAwesomeIcon icon={collapsed ? faChevronDown : faChevronUp} />
            </button>
            <label className="col-form-label">{t("Filters")}</label>
          </div>
        )}
      </div>
    </div>
  );
};

export default TrackDeploymentFilter;
